import { Client } from '@microsoft/microsoft-graph-client';
import type { IGraphClient } from '../../src/services/GraphService';
import { getToken } from './auth';

/**
 * A Graph client that authenticates with the given delegated scopes. Not interactive: never asks
 * the person to sign in or consent, for work they didn't start (it fails instead).
 */
export function createGraphClient(scopes: string[], interactive: boolean = true): IGraphClient {
  return Client.init({
    authProvider: done => {
      getToken(scopes, interactive).then(token => done(null, token)).catch(error => done(error, null));
    }
  });
}
